import { fromJS } from 'immutable';

export const visibleColumns = fromJS([
  'author',
  'year',
  'publication',
  'event',
  'geologicAgeOrder',
  'yearBegin',
  'yearEnd',
  'latitude',
  'longitude',
  'locationName',
  'country',
  'bodyOfWater',
  'description',
  'environment',
]);

export const sort = fromJS([
  { id: 'country', asc: true },
  { id: 'locationName', asc: true },
  { id: 'geologicAgeOrder', asc: true },
  { id: 'author', asc: true },
  { id: 'year', asc: true },
]);

export const minColumns = fromJS([]);
